<template>
  <div class="card">
    <div class="card-body">
      <div class="responsive-table">
        <template v-if="currentOrganized.winners && currentOrganized.winners.length===0">
          <div class="text-center p-3">
              <h5 class="font-size-24 m-3">Մասնակիցներ չլինելու պատճառով տվյալ գնման ընթացակարգը չի կայացել</h5>
              <button @click="cancelOrganize" class="btn btn-sm btn-primary btn mr-3">
                Ընթացակարգը համարել չկայացած 
              </button>
          </div>
        </template>
        <table v-else class="table m-0" style="border-collapse: collapse; border-spacing: 0; width: 100% !important;;">
          <thead>
            <tr>
              <th style="width: 120px;">Հ/Հ</th>
              <th>Մասնակցի անվանում</th>
              <th>Մասնակցի հեռախոսահամար</th>
              <th>Մասնակցի Էլ. հասցե</th>
              <th>Մասնակցի վավերապայմաներ</th>
              <th>Գնման առարկաներ</th>
              <th>Պայմանագրի գումար</th>
              <th>Փաստաթղթեր</th>
            </tr>
          </thead>
          <tbody id="comparison-table" style="min-height: 5vh; max-height: 40vh!important; overflow: scroll">
            <template v-for="(winner, winnerIndex) in currentOrganized.winners">
              <tr :key="winnerIndex">
                <td>{{ winnerIndex + 1 }}</td>
                <td>{{ winner.name }}</td>
                <td>{{ winner.phone }}</td>
                <td>{{ winner.email }}</td>
                <td>
                  <button
                    @click.prevent="() => {
                      $modal.show('winner-requirements-modal', winner)
                    }"
                    type="button" 
                    class="btn"
                    :class="winner.director ? 'btn-success' : 'btn-danger'"
                  >
                      Լրացնել
                  </button>
                </td>
                <td>
                  <span
                    :key="lot.toString() + lotIndex"
                    v-for="(lot, lotIndex) in winner.won_lots">
                      {{lot.is_from_outside ? lot.procurement_plan.cpv_outside.name : lot.procurement_plan.cpv.name}}<span v-if="lotIndex !== winner.won_lots.length-1">,</span>
                  </span>
                </td>
                <td v-if="Number.isInteger(getContractPrice(winner))"> {{ getContractPrice(winner) }}դր.</td>
                <td v-else> {{ getContractPrice(winner) }}դր.</td>
                <td>
                  <div class="row align-items-center justify-content-center">
                    <div class="row align-items-center" v-if="getIsSigned(winner)" >
                        <div class='col-12 mb-2 justify-content-start'>
                          Կնքված է
                        </div>
                    </div>
                      <div v-if="winner.suggestion.additional_file" class="col-12 justify-content-start mb-2">
                        <a 
                          :href="winner.suggestion.additional_file"
                          target="_blank"
                          download
                          class="btn btn-primary btn-sm"
                        >
                          Կցված փաստաթղթեր
                        </a>
                      </div>
                      <div v-if="currentOrganized.contract_html_hy !== ''" class="col-12 justify-content-start">
                        <button class="btn btn-primary btn-sm"
                          :disabled="winner.director===''"
                          @click.prevent="() => {
                            $modal.show('contract-modal', {index: winnerIndex+1, winner})
                          }"
                        >
                          Պայմանագիր
                        </button>
                      </div>
                      <div v-else>
                        
                      </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <winner-requirements-modal @updateComparisonData="resetData"/>
      <winner-lots-edit-modal @updateComparisonData="resetData"/>
      <contract-request-modal @updateComparisonData="resetData"/>
      <winner-evalution-modal @updateComparisonData="resetData"/>
      <new-editor-modal />
      <contract-modal />
      <editor-modal />
    </div>
  </div>
</template>

<script>
  import WinnerLotsEditModal from './modals/WinnerLotsEditModal'
  import WinnerEvalutionModal from './modals/WinnerEvalutionModal'
  import ContractRequestModal from './modals/ContractRequestModal'
  import NewEditorModal from '@/views/fileManagment/itender/NewEditorModal'
  import ContractModal from './modals/ContractModal'
  import EditorModal from '@/views/fileManagment/EditorModal'
  import WinnerRequirementsModal from '@/components/organize/WinnerRequirementsModal'

  export default {
    name: "ContractPreparation",
    components: {
      WinnerRequirementsModal,
      WinnerEvalutionModal,
      WinnerLotsEditModal,
      ContractRequestModal,
      NewEditorModal,
      ContractModal,
      EditorModal,
    },
    data() {
      return {
        participantGroups: [],
        notEstablished: true,
        organizedLots: [],
        pagination: {},
        tableData: [],
      }
    },
    computed: {
      locale() {
        return this.$store.getters["user/locale"];
      },
      currentOrganized() {
        return this.$store.getters['organizeItender/currentOrganized']
      },
    },
    mounted() {
      this.$store.dispatch('procurement/getPlans')
      this.$store.dispatch('organizeItender/getCurrent', this.$route.params.id)
      this.$store.dispatch('organizeItender/getRows', {organizeId: this.$route.params.id})
    },
    methods: {
      consoleLog(msg) {
        console.log(msg)
      },
      roundTwoDigits(number){
        return Math.round(number * 100) / 100
      },
      cancelOrganize(){
        this.$confirm(
          "Սույնով ընթացակարգը կհամարվի չկայացած", 
          "", 
          "info", 
          {
            confirmButtonText: 'Հաստատել', 
            cancelButtonText: 'Փակել'
          }
        ).then(text => {
          this.$client.get(`organize/itender/cancel/${this.currentOrganized.id}`).then(({data}) => {
            if(data.status){
              this.$router.push('/organizing/itender')
            }
          })
        })
      },
      getIsSigned(winner){
        var isSigned = true;
        winner.won_lots.forEach((lot) => {
          const offer = this.currentOrganized.lots.find(item => item.organize_row_id === lot.id && (item.participant_id === winner.id || item.row_group_id === winner.id))
          if(!offer.get_response){
            isSigned = false;
          }
        })
        return isSigned
      },
      getContractPrice(winner){
        var sumPrice = 0;
        if(this.currentOrganized.winner_by_lots){
          winner.won_lots.forEach((lot) => {
            const offer = this.currentOrganized.lots.find(item => item.organize_row_id === lot.id && (item.participant_id === winner.id || item.row_group_id === winner.id))

            const newPrice = offer.new_value
            const price = offer.value
            const vat = offer.vat
            if(vat){
              if(newPrice){
                sumPrice = sumPrice + (newPrice+newPrice*0.2)
              } else {
                sumPrice = sumPrice + (price+price*0.2)
              }
            } else {
              if(newPrice){
                sumPrice = sumPrice + (newPrice)
              } else {
                sumPrice = sumPrice + (price)
              }
            }
          })
        } else {
          sumPrice = this.currentOrganized.winner_user_price
        }
        return sumPrice
      },
      resetData() {
        this.pagination = {}
        this.participantGroups = []
        this.$store.dispatch('organizeItender/getCurrent', this.$route.params.id)
        this.$store.dispatch('organizeItender/getRows', {organizeId: this.$route.params.id})
      },
    },
  }
</script>

<style scoped>
.fa-file-download{
  cursor: pointer;
}
</style>
